export default __webpack_public_path__ + "static/media/background.fb47234f.png";